<template>
  <div class="main-content">
    <div class="info-cards-grid">
      <div
        v-for="(item, index) in projectInfoList"
        :key="item.key"
        class="info-card"
        :style="{
          backgroundImage: `url(${require(`@/assets/images/chatpreview/project_info_${index + 1}.png`)})`,
        }"
      >
        <div class="card-content">
          <div class="card-label">{{ item.label }}:</div>
          <el-tooltip
            :content="item.value"
            :disabled="!overflowMap[index]"
            placement="bottom"
            effect="light"
            :open-delay="300"
            popper-class="chat-preview-tooltip"
          >
            <div 
              class="card-value" 
              :ref="`cardValue-${index}`"
            >
              {{ item.value }}
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectInfo",
  props: {
    previewData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      overflowMap: {}, // 存储每个索引对应的文字是否被截断
    };
  },
  computed: {
    projectInfoList() {
      if (!this.previewData) {
        return [];
      }
      const list = Object.keys(this.previewData).map((key) => {
        const item = this.previewData[key];
        return {
          key,
          index: item?.index || 0,
          label: item?.label || "-",
          value: item?.value || "-",
        };
      });
      list.sort((a, b) => a.index - b.index);
      return list;
    },
  },
  watch: {
    projectInfoList: {
      handler() {
        this.$nextTick(() => {
          this.checkAllTextOverflow();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // 组件挂载后检查文字是否被截断
    this.$nextTick(() => {
      this.checkAllTextOverflow();
    });
  },
  methods: {
    checkTextOverflow(index) {
      const refName = `cardValue-${index}`;
      const refs = this.$refs[refName];
      // refs 可能是数组（如果 v-for 中有多个相同 ref）或单个元素
      const el = Array.isArray(refs) ? refs[0] : refs;
      if (el) {
        // 比较 scrollWidth 和 clientWidth，如果 scrollWidth 更大，说明文字被截断了
        const isOverflow = el.scrollWidth > el.clientWidth;
        this.$set(this.overflowMap, index, isOverflow);
      }
    },
    checkAllTextOverflow() {
      // 重置 overflowMap
      this.overflowMap = {};
      // 检查所有元素
      this.projectInfoList.forEach((item, index) => {
        this.checkTextOverflow(index);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  height: 100%;
}

.info-cards-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 12px;
  padding: 8px 12px;
}

.info-card {
  width: 100%;
  height: 45px;
  background-size: contain;
  background-position: left;
  background-repeat: no-repeat;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  // transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
  // transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-content {
  width: 100%;
  height: 100%;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  color: rgba(5, 32, 49, 1);
}

.card-label {
  font-size: 14px;
  font-weight: 400;
  margin-right: 4px;
  white-space: nowrap;
  flex-shrink: 0;
}

.card-value {
  font-size: 14px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
